import { useEffect } from 'react'
import { LegacyQuizScreen } from '../config/types'

/**
 * Prefetches the topImage of the next screen in the quiz flow.
 * Injects a <link rel="prefetch"> into <head> so the browser downloads
 * the image at low priority while the user reads the current screen.
 * By the time they tap Continue, the image is already cached.
 */
export const usePrefetchNextImage = (screens: LegacyQuizScreen[], currentPageIndex: number): void => {
  useEffect(() => {
    // Look ahead for the next screen(s) that have a topImage
    const links: HTMLLinkElement[] = []

    for (let i = currentPageIndex + 1; i < Math.min(currentPageIndex + 3, screens.length); i++) {
      const nextImage = screens[i]?.topImage
      if (nextImage) {
        const link = document.createElement('link')
        link.rel = 'prefetch'
        link.as = 'image'
        link.href = nextImage
        document.head.appendChild(link)
        links.push(link)
      }
    }

    return () => {
      links.forEach((link) => link.remove())
    }
  }, [screens, currentPageIndex])
}
